import { render } from "./StudyPlanLength.vue?vue&type=template&id=74c44ced"
import script from "./StudyPlanLength.vue?vue&type=script&lang=js"
export * from "./StudyPlanLength.vue?vue&type=script&lang=js"

import exportComponent from "/opt/microsoft-academy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__